const getBankCorrespondingView = (pathname, scope) => {
  if (scope === "bank") {
    //Dynamic routes
    if (pathname.includes("/rules")) return "matching-rules"; //matching rules
    if (pathname.includes("/reports")) return "reports"; //matching rules details
    //Insert the rest of dynamic routes here

    //Static routes
    switch (pathname) {
      case "/":
        return "overview";
      case "/swift-day":
        return "swift-day";
      case "/swift-search":
        return "swift-search";
      case "/admin-tool/bank-settings":
        return "bank-settings";
      case "/admin-tool/search-archive":
        return "search-archive-settings";
      case "/admin-tool/alerts-notifications":
        return "alerts-notifications";
      case "/alerts-settings":
        return "alerts-settings";
      case "/internal-alerts":
        return "internal-alerts";
      case "/generated-notifications":
        return "generated-notifications";
      case "/customers-list":
        return "customers-list";
      case "/customers-groups":
        return "customers-groups";
      case "/matching-rules":
        return "matching-rules";
      case "/matching-day":
        return "matching-day";
      case "/license":
        return "license";
      case "/license/modules":
        return "license-modules";
      case "/reports":
        return "reports";
      default:
        return null;
    }
  }
};

export default getBankCorrespondingView;
